import React, { forwardRef, useState } from 'react';

import { Input, Button } from 'antd';

//ico_plus.png
const BaseItemInput = (props) => {
  const { onClick, text, ...rest } = props;
  const [value, setValue] = useState(null);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: '3.5rem',
      border: '1px solid #DBDADE',
      borderRadius: 4,
      margin: 0,
      padding: 0,
    },
  };

  return (
    <div style={{ ...styles.container }}>
      <Input
        value={value}
        style={{ border: 0 }}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      />
      <Button
        style={{ border: 0, padding: 0 }}
        icon={
          <img
            width={35}
            height={35}
            src={require('../../assets/images/ico_plus.png')}
          />
        }
        onClick={(e) => {
          setValue('');
          onClick({ value });
        }}
      />
    </div>
  );
};

export default forwardRef(BaseItemInput);
